import { chat } from "../helpers/webinar-chat";
import { activateSurvey, submitSurveyHandler } from '../helpers/satisfaction-survey';
import { computeFaqClick } from '../helpers/faq-helper';
import { relatedContent } from '../helpers/search-helpers';
import { requestReasonForJoining } from '../helpers/webinar-helper';
import { createNotificationConsumer } from "../channels/message_notification_channel";

document.addEventListener('turbolinks:load', function() {
  const body = $('body');
  if (body.data('controller') !== 'instances' || body.data('action') !== 'show') return;

  chat();
  activateSurvey();
  relatedContent('.question-ajax-form', '.question-container','related_content', '.related-content .category-container');
  computeFaqClick();
  requestReasonForJoining();
  createNotificationConsumer();
  submitSurveyHandler();
});
